const LOAD_SEARCH_ADDRESS = window.location.search;
export default function load() {

    // load ok sdk
    if (/web_server=https%3A%2F%2F(m\.)?ok\.ru/.test(LOAD_SEARCH_ADDRESS)) {
        return import('./SdkOk') as Promise<any>
    }
    return Promise.reject();
}
